// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2fXG1","box":"WorkspacesBox_box__2m53-","node":"WorkspacesBox_node__2rv2I"};